import * as React from "react";

export const StatusIcon = ({ color, width, height, ...props }: any) => {
  return (
    <svg
      width={width ? width : 6}
      height={height ? height : 6}
      viewBox="0 0 6 6"
      fill="none"
      {...props}
    >
      <circle cx={3} cy={3} r={3} fill={color || "#F66"} />
    </svg>
  );
};
